<template>
	<div>
		<div id="copy-confirmation-dialog" style="display: none;">
			<h2>This form has been successfully copied!</h2>
			<p><i class="icon-exclamation-triangle icon-2x c-warning"></i><span></span></p>
		</div>

		<div id="copy-within-org-confirmation-dialog" style="display: none;">
			<h2>This form has been successfully copied!</h2>
			<p><i class="icon-exclamation-triangle icon-2x c-warning"></i>All form settings have been copied. Please review form, payment and submission settings before submitting new entries.</p>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';

	export default defineComponent({});
</script>
